<template>
  <div class="LeadView lead-details-window">
    <div class="lead-details-window-wrapper">
      <div class="leads-details-content">
        <div id="lead-view" class="lead-view-container">
          <lead-view-left />
          <lead-view-right />
        </div>

        <router-link class="lead-details-close" to="/"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LeadViewLeft from "./partials/LeadViewLeft";
import LeadViewRight from "./partials/LeadViewRight";

export default {
  name: "LeadView",
  components: {LeadViewRight, LeadViewLeft},
  mounted() {
    this.$store.dispatch('getLead', this.$route.params.id).then(() => {
      this.getPrograms();
      this.changeTab('sp_trades');
      // this.changeTab('comment');
    });
  }
}
</script>

<style lang="scss">
.LeadView {
  .error {
    color: #c20b0b;
  }
}
</style>
